import { createBrowserRouter, Navigate } from "react-router-dom";

import {
  AppstoreOutlined,
  UserOutlined,
  VideoCameraOutlined,
  CreditCardOutlined,
  SettingOutlined,
  SolutionOutlined,
  ShoppingOutlined,
  TransactionOutlined,
  SwapLeftOutlined,
  ProjectOutlined,
  MonitorOutlined,
  DollarOutlined,
} from "@ant-design/icons";

import Root from "pages/Root";
import Activity from "pages/Activity";
import BasicInfo from "pages/BasicInfo";
import TicketsSetting from "pages/ticketsSetting/TicketsSetting";
import JoinList from "pages/joinList/JoinList";
import TaxSetting from "pages/TaxSetting";
import PayMethods from "pages/PayMethods";
import RefundMethods from "pages/RefundMethods";
import Registration from "pages/Registration";
import Tickets from "pages/Tickets";
import LogIn from "pages/login/LogIn";
import Events from "pages/Events";
import Scan from "pages/Scan";
import Members from "pages/members";

export const router = createBrowserRouter([
  {
    key: "login",
    path: "/login",
    element: <LogIn />,
  },
  {
    key: "root",
    path: "/",
    element: <Root />,
    children: [
      {
        key: "events",
        label: "活動列表",
        path: "/events",
        icon: <AppstoreOutlined />,
        element: <Events />,
        level: 16,
      },
      {
        key: "members",
        label: "會員中心",
        path: "/members",
        icon: <UserOutlined />,
        element: <Members />,
        level: 16,
      },
      {
        key: "scan",
        label: "票券驗證",
        path: "/scan",
        icon: <MonitorOutlined />,
        element: <Scan />,
        level: 1,
      },
      // 以下都是內層頁面
      {
        key: "backToEvents",
        label: "返回活動列表",
        path: "/events",
        icon: <SwapLeftOutlined />,
        level: 16,
      },
      {
        key: "basicInfo",
        label: "基本資訊",
        path: "/basicInfo/:id",
        icon: <ProjectOutlined />,
        element: <BasicInfo />,
        level: 16,
      },
      {
        key: "activity",
        label: "活動內容",
        path: "/activity/:id",
        icon: <VideoCameraOutlined />,
        element: <Activity />,
        level: 16,
      },
      {
        key: "taxSetting",
        label: "稅務設定",
        path: "/taxSetting",
        icon: <DollarOutlined />,
        element: <TaxSetting />,
        level: 16,
      },
      {
        key: "ticketsSetting",
        label: "票卷設定",
        path: "/ticketsSetting/:id",
        icon: <SettingOutlined />,
        element: <TicketsSetting />,
        level: 16,
      },
      {
        key: "joinList",
        label: "參加名單",
        path: "/joinList/:id",
        icon: <UserOutlined />,
        element: <JoinList />,
        level: 16,
      },
      // {
      //   key: "payMethods",
      //   label: "付款方式",
      //   path: "/payMethods",
      //   icon: <CreditCardOutlined />,
      //   element: <PayMethods />,
      // },
      // {
      //   key: "refundMethods",
      //   label: "退費方式",
      //   path: "/refundMethods",
      //   icon: <TransactionOutlined />,
      //   element: <RefundMethods />,
      // },
      // {
      //   key: "registration",
      //   label: "報名表",
      //   path: "/registration",
      //   icon: <SolutionOutlined />,
      //   element: <Registration />,
      // },
      {
        key: "tickets",
        label: "售票資訊",
        path: "/tickets/:id",
        icon: <ShoppingOutlined />,
        element: <Tickets />,
        level: 16,
      },
      {
        path: "*",
        element: <Navigate to="/basicInfo" replace />,
      },
    ],
  },
]);
